var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shop",
    clipPath: "url(#clip0_9675_384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.18188 10.9878V16.8182C3.18188 16.999 3.25372 17.1724 3.38158 17.3003C3.50945 17.4282 3.68287 17.5 3.8637 17.5H16.1364C16.3173 17.5 16.4907 17.4282 16.6185 17.3003C16.7464 17.1724 16.8182 16.999 16.8182 16.8182V10.9878",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.69312 2.5H16.3068C16.4549 2.50003 16.5989 2.54828 16.7172 2.63747C16.8354 2.72666 16.9214 2.85192 16.9621 2.99432L18.1818 7.27273H1.81812L3.04027 2.99432C3.08088 2.85234 3.16649 2.72738 3.28422 2.63824C3.40195 2.54909 3.54544 2.50058 3.69312 2.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.27266 7.27271V8.63634C7.27266 9.35966 6.98532 10.0534 6.47386 10.5648C5.9624 11.0763 5.26871 11.3636 4.54539 11.3636C3.82207 11.3636 3.12838 11.0763 2.61691 10.5648C2.10545 10.0534 1.81812 9.35966 1.81812 8.63634V7.27271",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7273 7.27271V8.63634C12.7273 9.35966 12.4399 10.0534 11.9285 10.5648C11.417 11.0763 10.7233 11.3636 9.99998 11.3636C9.27666 11.3636 8.58297 11.0763 8.0715 10.5648C7.56004 10.0534 7.27271 9.35966 7.27271 8.63634V7.27271",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1818 7.27271V8.63634C18.1818 9.35966 17.8945 10.0534 17.383 10.5648C16.8716 11.0763 16.1779 11.3636 15.4546 11.3636C14.7312 11.3636 14.0376 11.0763 13.5261 10.5648C13.0146 10.0534 12.7273 9.35966 12.7273 8.63634V7.27271",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9675_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileShop);
export default __webpack_public_path__ + "static/media/profile-shop.7661244ff74f7344cb1458566302198d.svg";
export { ForwardRef as ReactComponent };